import { useTranslation } from '../i18n';
import React from 'react';
import {
    CloudServerOutlined, ThunderboltOutlined, SafetyCertificateOutlined, GlobalOutlined,
} from '@ant-design/icons';
import BrandLogo from './BrandLogo';

/**
 * 登录 / 注册 / 重置密码的两栏布局（2026-10-07 与官网对齐）：
 * 左侧深海军蓝品牌栏（logo + 价值主张），右侧表单。≤900px 收为单栏。
 * 颜色全部走 CSS 变量，暗色模式可用（不再写死 #f0f2f5）。
 */
const POINTS = [
    { icon: <CloudServerOutlined />, title: '计算', text: '云服务器、应用容器、共享主机与轻应用，按需开通' },
    { icon: <ThunderboltOutlined />, title: '网络与 CDN', text: '全球加速、智能 DNS 与边缘函数，统一控制台管理' },
    { icon: <SafetyCertificateOutlined />, title: '安全', text: 'SSL 证书、WAF 与两步验证，默认安全' },
    { icon: <GlobalOutlined />, title: '多地域', text: '覆盖三大洲的基础设施，就近服务您的用户' },
];

const AuthLayout = ({ title, subtitle, children }) => {
    const { t } = useTranslation();
    return (
    <div className="auth-shell">
        <aside className="auth-brand" aria-hidden="false">
            <BrandLogo invert size={32} />
            <div>
                <h1>{t('Manage all your cloud resources in one console')}</h1>
                <p className="lead">{t('Yeap Cloud public cloud platform')}</p>
                <ul className="auth-points">
                    {POINTS.map((p) => (
                        <li key={p.title}>
                            {p.icon}
                            <span><b>{t(p.title)}</b>{t(p.text)}</span>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="auth-foot">© {new Date().getFullYear()} Yeap Cloud · <a href="https://yeap.cloud" style={{ color: 'inherit' }}>yeap.cloud</a></div>
        </aside>
        <main className="auth-main">
            <div className="auth-card">
                <div className="auth-mobile-logo"><BrandLogo size={30} /></div>
                {title && <h2 className="auth-card-title">{title}</h2>}
                {subtitle && <p className="auth-card-sub">{subtitle}</p>}
                {children}
            </div>
        </main>
    </div>
);
};

export default AuthLayout;
